import { useContext } from "react";
import { LoaderContext } from "../components/utils/loaderContext";
import { API_Endpoints } from "../constants";
import { NotificationContext } from "../components/utils/notificationContext";
import { getAPI, postAPI } from "./http.service";
import { ISettings } from "../components/settings/settings";

export class SettingsService {
    private endpoints = API_Endpoints();
    loaderContext = useContext(LoaderContext);
    private notificationContext = useContext(NotificationContext);

    getSettings = async () => {
        return await getAPI(this.endpoints.settingsURL)
            .then((res: { data: any; }) => {
                return res.data;
            }).catch(err => {
                this.loaderContext.setLoader(false);
                this.notificationContext.setNotification({ ...err })
            });
    }

    submitSettings = async (data: ISettings) => {
        this.loaderContext.setLoader(true);
        return await postAPI(this.endpoints.settingsURL, data)
            .then((res: { data: any; }) => {
                this.loaderContext.setLoader(false);
                return res;
            }).catch(err => {
                this.loaderContext.setLoader(false);
                this.notificationContext.setNotification({ ...err })
            });
    }
}

export const SettingsService2 = {
    getSettings: async () => {
        return await getAPI(API_Endpoints().settingsURL)
    }
}

